import * as path from 'node:path';
import type { WorktreeLayoutKind } from '../worktree-layout-kind.js';
import { layoutDirSegments } from '../worktree-layout-kind.js';
import type { WorktreeLayoutFile } from '../worktree-layout-file.js';
import { allocateDirNameForLauncherCwd } from '../worktree-layout-file.js';

export function resolveIsolatedScopeDir(options: {
  worktreesRootPath: string;
  bridgeRoot: string;
  kind: WorktreeLayoutKind;
  scopeId: string;
  layout: WorktreeLayoutFile;
}): { bridgeResolved: string; scopeDir: string } {
  const bridgeResolved = path.resolve(options.bridgeRoot);
  const cwdKey = allocateDirNameForLauncherCwd(options.layout, bridgeResolved);
  const bridgeKeyDir = path.join(options.worktreesRootPath, cwdKey);
  const scopeDir = path.join(bridgeKeyDir, ...layoutDirSegments(options.kind, options.scopeId));
  return { bridgeResolved, scopeDir };
}
